/**
 * Settings API — currencies and their rates. The API's currencies table is the
 * single source of rates (DUBVM-155): it refreshes them daily, and every line
 * save, Recalculate, FX lock and import converts at them.
 */

import { apiFetch } from './fetch';
import { API } from '../constants';
import type { CurrencyRate, ConversionRate } from '../types/dvms.types';

/** Currency codes the backend accepts — the single source for every currency dropdown. */
export async function getSupportedCurrencies(): Promise<string[]> {
    const resp = await apiFetch<{ currencies: string[] }>(API.SETTINGS_SUPPORTED_CURRENCIES);
    return resp.currencies;
}

export async function getCurrencyRates(): Promise<CurrencyRate[]> {
    return apiFetch<CurrencyRate[]>(API.SETTINGS_CURRENCY_RATES);
}

/** Fetch conversion rates from a base currency to all configured currencies. */
export async function getConversionRates(baseCurrency: string): Promise<ConversionRate[]> {
    return apiFetch<ConversionRate[]>(`${API.SETTINGS_CURRENCY_RATES}?base=${encodeURIComponent(baseCurrency)}`);
}

/** Fetch a single conversion rate between two currencies. */
export async function getConversionRate(baseCurrency: string, targetCurrency: string): Promise<ConversionRate> {
    return apiFetch<ConversionRate>(
        `${API.SETTINGS_CURRENCY_RATES}?base=${encodeURIComponent(baseCurrency)}&target=${encodeURIComponent(targetCurrency)}`,
    );
}

export async function exportCurrencyRatesCsv(): Promise<{ url: string; count: number }> {
    return apiFetch<{ url: string; count: number }>(API.SETTINGS_CURRENCY_CSV);
}
